/** Only the original occurrence clock controls a transient bubble, never delivery time. */
export function narrativeBubbleRemainingMs(atUTC: string | undefined, now: number, lifetimeMs: number): number {
  if (atUTC === undefined) return lifetimeMs; // Older live protocol has no occurrence clock.
  const start = Date.parse(atUTC);
  if (!Number.isFinite(start) || start > now) return 0;
  return Math.max(0, lifetimeMs - (now - start));
}
